export default __webpack_public_path__ + "static/media/partner3.9c410af2.svg";